import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';

const EditPaymentPlanModal = ({ show, handleClose, paymentplan, handleSave }) => {

    const [installments, setInstallments] = useState('');
    const [downpayment, setDownpayment] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (paymentplan) {

            setInstallments(paymentplan.installments || '');
            setDownpayment(paymentplan.downpayment || '');
        }
    }, [paymentplan]);

    const handleSaveClick = () => {
        setLoading(true);
        const updatedPaymentPlan = {
            ...paymentplan,

            installments,
            downpayment
        };


        api.put(`/paymentplans/${updatedPaymentPlan.id}`, updatedPaymentPlan).then(response => { console.log(response.data) }).catch(error => { console.log(error) });

        console.log('Payment Plan Data:', updatedPaymentPlan);
        setLoading(false);
        handleClose();

        handleSave(updatedPaymentPlan);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit Payment Plan</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>

                    {/* Installments */}
                    <Form.Group controlId="installments" className="mb-3">
                        <Form.Label>Installments</Form.Label>
                        <Form.Control
                            type="number"
                            value={installments}
                            onChange={(e) => setInstallments(e.target.value)}
                            min="1"
                        />
                    </Form.Group>

                    {/* Downpayment */}
                    <Form.Group controlId="downpayment" className="mb-3">
                        <Form.Label>Downpayment</Form.Label>
                        <Form.Control
                            type="number"
                            value={downpayment}
                            onChange={(e) => setDownpayment(e.target.value)}
                            min="0"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleSaveClick} disabled={loading}>
                    {loading ? <Spinner animation="border" size="sm" /> : 'Save Changes'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditPaymentPlanModal;
